import PropTypes from "prop-types"
import React, { useContext } from "react"

import { POSContext } from "../Layout"

const LaunchDockwaPayModalButton = ({ onClickCallback = () => {} }) => {
  const { setDockwaPayModalOpen } = useContext(POSContext)

  return (
    <div
      className="flex h-full cursor-pointer flex-col justify-center space-y-2 rounded border border-gray-300 p-4 text-center text-gray-600 hover:border-gray-900 hover:bg-gray-100 hover:text-gray-900"
      role="button"
      onClick={() => {
        setDockwaPayModalOpen(true)
        onClickCallback()
      }}
    >
      <i className="fa-solid fa-qrcode text-4xl" />
      <span className="font-semibold">Scan Dockwa Pay QR Code</span>
    </div>
  )
}

LaunchDockwaPayModalButton.propTypes = {
  onClickCallback: PropTypes.func,
}
export default LaunchDockwaPayModalButton
